import { render, staticRenderFns } from "./paperreq.vue?vue&type=template&id=949ab8c2&scoped=true"
import script from "./paperreq.vue?vue&type=script&lang=js"
export * from "./paperreq.vue?vue&type=script&lang=js"
import style0 from "./paperreq.vue?vue&type=style&index=0&id=949ab8c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949ab8c2",
  null
  
)

export default component.exports